import { createSlice } from '@reduxjs/toolkit';
import { clearAuthTokens } from '../../services/authTokens';

const initialState = {
  user: null,
  isAuthenticated: false,
  // true until bootstrapAuth finishes — AuthGuard must not redirect before then
  loading: true,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action) {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    logout(state) {
      state.user = null;
      state.isAuthenticated = false;
      clearAuthTokens();
    },
  },
});

export const { setUser, setLoading, logout } = authSlice.actions;
export default authSlice.reducer;
